import React, { useEffect, useState } from "react";
import { UserCheck } from "lucide-react";
import api from "@/lib/api";

export const FormReferenceSelect = ({ value, onChange, pmName }) => {
  const [members, setMembers] = useState([]);
  useEffect(() => { api.get("/growth/reference-members").then((r) => setMembers(r.data || [])).catch(() => {}); }, []);
  return (
    <div className="rounded-xl bg-amber-50/50 border border-amber-200 p-4" data-testid="form-reference-section">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-amber-100 border border-amber-200 flex items-center justify-center shrink-0 mt-0.5">
          <UserCheck className="w-4 h-4 text-amber-700" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-slate-900 text-sm">Reference member (optional)</div>
          <div className="text-xs text-slate-500 mt-1">
            Every <b>paid</b> delegate from this form counts for this member and earns them leaderboard XP.
            If left empty, delegates count for the event&apos;s project manager{pmName ? <> (<b>{pmName}</b>)</> : null}.
            Never shown on the public form.
          </div>
          <select
            className="input-pill mt-3 w-full sm:w-80"
            value={value || ""}
            onChange={(e) => onChange(e.target.value || null)}
            data-testid="form-reference-select"
          >
            <option value="">None: count for project manager</option>
            {members.map((m) => (
              <option key={m.user_id} value={m.user_id}>{m.name || m.email} · {m.role_label}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};
